import styled from 'styled-components'

const Label = styled.label`
  color: #FFFFFF;
  font-size: 1em;
  line-height: 2em;
  margin-bottom: 1em;
`
export default Label



// WEBPACK FOOTER //
// ./src/components/Form/Label.js